import PropTypes from 'prop-types';
import authService, { privileges } from '../../services/AuthService';

const CanDelete = ({ on = null, children = null, fallback = null }) => {
  if (!children) return null;
  if (on) {
    if (
      !authService.hasPermission({
        functionality: on,
        privilege: privileges.Delete,
      })
    )
      return fallback;
  }

  return children;
};

CanDelete.propTypes = {
  on: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]),
  children: PropTypes.node,
  fallback: PropTypes.node,
};
export default CanDelete;
